import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetIdfaRequestConfigsQuery, useUpdateIdfaRequestConfigMutation } from '../../../api/idfaRequestConfigsApiSlice';
import CollapsableIdfaRequestConfig from '../../../components/sdk/CollapsableIdfaRequestConfig';
import TreeBorderStructure from '../../../components/TreeBorderStructure';

const PublisherIdfaRequestConfig = () => {
  const publisherId = useParams()["publisherId"];
  const {data : idfaRequests = {}, isSuccess, refetch} = useGetIdfaRequestConfigsQuery(publisherId)
  const { t } = useTranslation();
  const [updateIdfaRequestConfig] = useUpdateIdfaRequestConfigMutation()

  if (! isSuccess) { return (<></>) }

  return (
    <>
      <TreeBorderStructure>
        <CollapsableIdfaRequestConfig
          title={idfaRequests.name}
          icon={"publishers"}
          closeBtnText={t('idfaRequestConfig.default_config')}
          onSave={updateIdfaRequestConfig}
          data={{...idfaRequests, publisher_id: publisherId}}/>
        {
          idfaRequests.apps && idfaRequests.apps.map((app, i) => {
            return (
              <CollapsableIdfaRequestConfig
                title={app.name}
                key={i}
                icon={app.os}
                closeBtnText={t('idfaRequestConfig.config')}
                onSave={updateIdfaRequestConfig}
                data={{...app, publisher_id: publisherId}}/>
            )
          })
        }
      </TreeBorderStructure>
    </>
  )
}

export default PublisherIdfaRequestConfig;
